/*
 * @Author: Lemon C
 * @Date: 2024-05-09 15:37:53
 * @LastEditTime: 2025-09-29 11:53:53
 */

const nav_item_list = [
    { name: '首页', route: '/home', type: 0 },
    { name: '产品功能', route: '/product-ability', type: 1 },
    { name: '开发者文档', route: '/docs-center', type: 2 },
    { name: '下载与更新', route: '/developer-updates', type: 3 },
    // { name: '黑洞生态', route: '/ecology', type: 4 },
    // { name: '联系我们', route: '/contact', type: 5 },
    { name: '常见问题', route: '/docs/faq', type: 6 },
]; //导航栏列表

const group = {
    service: 50, // 服务
    js: 60, // web
    ios: 62, // iOS
    android: 61, // 安卓
    streaming: 63, // 云渲染
    course: 2, // 教程
    demo: 40, // Demo
    guide: 1, // 指南
    faq: 4, // FAQ
    notice: 3, // 公告
    toolUseGuide: 5, // 工具使用指南
    platform: 11, // 平台
    plugin: 76, // 插件
    sdk: 10, // SDK
};

const docs_switch = {
    all: 100, // 全部
    center: 101, // 开发者文档
    toolUseGuide: 102, // 工具使用指南
    guide: 103, // 开发指南
    course: 104, // 开发教程
    service: 105, // 服务端接口
    js: 106, // JavaScript接口
    android: 107, // Android接口
    ios: 108, // iOS接口
    demo: 109, // Demo接口
    faq: 110, // FAQ
    update: 111, // 下载与更新
    streaming: 112, // 云渲染接口
}; // 开发文档类型

const docs_switch_list = [
    { name: '开发者文档', id: 101, route: '/docs-center', isActive: false },
    { name: '工具使用指南', id: 102, route: '/docs/tool-use-guide', isActive: false },
    { name: '开发指南', id: 103, route: '/docs/guide', isActive: false },
    { name: '开发教程', id: 104, route: '/docs/course', isActive: false },
    { name: '服务端接口', id: 105, route: '/docs/service-api', isActive: false },
    { name: 'JavaScript接口', id: 106, route: '/docs/js-api', isActive: false },
    { name: 'Android接口', id: 107, route: '/docs/android-api', isActive: false },
    { name: 'iOS接口', id: 108, route: '/docs/ios-api', isActive: false },
    { name: '云渲染接口', id: 112, route: '/docs/streaming-api', isActive: false },
    { name: 'Demo接口', id: 109, route: '/docs/web-demo', isActive: false },
]; // 文档类型列表

const search_tree_obj = {
    all_id: 999,
    dev_id: 888,
    update_id: 666,
}; //搜索中心目录树配置id

const search_tree_list = [
    { name: '全部', id: search_tree_obj.all_id, type: docs_switch.all, count: 0, subCatalogs: [] },
    {
        name: '开发文档',
        id: search_tree_obj.dev_id,
        type: docs_switch.center,
        count: 0,
        subCatalogs: [
            {
                name: '工具使用指南',
                id: group.toolUseGuide,
                type: docs_switch.toolUseGuide,
                count: 0,
                subCatalogs: [],
            },
            { name: '开发指南', id: group.guide, type: docs_switch.guide, count: 0, subCatalogs: [] },
            { name: '开发教程', id: group.course, type: docs_switch.course, count: 0, subCatalogs: [] },
            { name: '服务端接口', id: group.service, type: docs_switch.service, count: 0, subCatalogs: [] },
            { name: 'JavaScript接口', id: group.js, type: docs_switch.js, count: 0, subCatalogs: [] },
            { name: 'Android接口', id: group.android, type: docs_switch.android, count: 0, subCatalogs: [] },
            { name: 'iOS接口', id: group.ios, type: docs_switch.ios, count: 0, subCatalogs: [] },
            { name: '云渲染接口', id: group.streaming, type: docs_switch.streaming, count: 0, subCatalogs: [] },
            { name: 'Demo示例', id: group.demo, type: docs_switch.demo, count: 0, subCatalogs: [] },
        ],
    },
    { name: 'FAQ', id: group.faq, type: docs_switch.faq, count: 0, subCatalogs: [] },
    { name: '下载与更新', id: search_tree_obj.update_id, count: 0, type: docs_switch.update, subCatalogs: [] },
]; //搜索中心目录树

const docs_content_type = {
    api: 20,
    md: 10,
}; // 接口的文档类型

const docs_update_type = {
    sdk: 'sdk-update',
    plugin: 'plugin-update',
    platform: 'platform-update',
}; // 更新日志类型

const docs_center_promise = {
    update: 'update-service',
    faq: 'faq-service',
    course: 'course-service',
    demo: 'demo-service',
}; // 开发者文档首页请求类型

const router_nav_path = [
    { type: 0, path: '/home' }, // 首页
    { type: 0, path: '/msg-center' }, // 消息中心
    { type: 1, path: '/product-ability' }, // 产品功能
    { type: 1, path: '/product-ability/func-detail' }, // 功能介绍详情
    { type: 1, path: '/product-ability/func-list' }, // 功能列表
    { type: 2, path: '/docs-center' }, // 开发者文档
    { type: 2, path: '/docs/service-api' }, // 服务
    { type: 2, path: '/docs/js-api' }, // web
    { type: 2, path: '/docs/ios-api' }, // iOS
    { type: 2, path: '/docs/android-api' }, // 安卓
    { type: 2, path: '/docs/streaming-api' }, // 云渲染
    { type: 2, path: '/docs/course' }, // 教程
    { type: 2, path: '/docs/web-demo' }, // Demo
    { type: 2, path: '/docs/guide' }, // 指南
    { type: 2, path: '/docs/tool-use-guide' }, // 工具使用指南
    { type: 2, path: '/search-center' }, // 搜索
    { type: 3, path: '/developer-updates' }, // 下载与更新
    { type: 4, path: '/ecology' }, // 黑洞生态
    { type: 5, path: '/contact' }, // 联系我们
    { type: 6, path: '/docs/faq' }, // FAQ
]; //导航栏路由类型

const router_type = {
    home: '/home', //首页
    service: '/docs/service-api', // 服务
    js: '/docs/js-api', // web
    ios: '/docs/ios-api', // iOS
    android: '/docs/android-api', // 安卓
    streaming: '/docs/streaming-api', // 云渲染
    course: '/docs/course', // 教程
    demo: '/docs/web-demo', // Demo
    guide: '/docs/guide', // 指南
    faq: '/docs/faq', // FAQ
    toolUseGuide: '/docs/tool-use-guide', // 工具使用指南
    updatelog: '/developer-updates', // 下载与更新
    search: '/search-center', // 搜索
    msg: '/msg-center', // 消息中心
    func_detail: '/product-ability/func-detail', //功能介绍详情
    func_list: '/product-ability/func-list', //功能列表
    contact_us: '/contact', //联系我们
}; // 路由地址

const router_path = [
    { type: 50, url: '/docs/service-api' }, // 服务
    { type: 60, url: '/docs/js-api' }, // web
    { type: 62, url: '/docs/ios-api' }, // iOS
    { type: 61, url: '/docs/android-api' }, // 安卓
    { type: 63, url: '/docs/streaming-api' }, // 云渲染
    { type: 2, url: '/docs/course' }, // 教程
    { type: 40, url: '/docs/web-demo' }, // Demo
    { type: 1, url: '/docs/guide' }, // 指南
    { type: 4, url: '/docs/faq' }, // FAQ
    { type: 5, url: '/docs/tool-use-guide' }, // 工具使用指南
    { type: 11, url: '/developer-updates' }, // 下载与更新
    { type: 76, url: '/developer-updates' }, // 下载与更新
    { type: 10, url: '/developer-updates' }, // 下载与更新
]; //路由地址匹配类型

const color = {
    __color_main_light_bg: '#f8faff',
    __color_main_light_bg_white: '#ffffff',
    __color_main_dark_bg: '#0d0d0e',
    __color_main_gray_bg: '#f2f3f5',
    __color_main_nav_light_bg: '#ffffff',
    __color_main_nav_dark_bg: '#0d0d0e',
    __color_main_transparent_bg: 'transparent',
    __color_main_brand: '#185cff',
    __color_main_brand_hover: '#467dff',
    __color_main_brand_hover_light: '#e5edff',
    __color_main_brand_active: '#185cff',
    __color_main_text_disabled: '#bdbdbd',
    __color_main_text_secondary: '#5d5f64',
    __color_main_text_brand: '#185cff',
    __color_main_text_brand_bg_primary: '#ffffff',
    __color_main_text_dark_bg_primary: '#ffffff',
    __color_main_text_dark_bg_secondary: '#f3f3f3',
    __color_main_text_nav_light_bg_default: '#1b2559',
    __color_main_text_nav_dark_bg_default: '#ffffff',
    __color_main_text_nav_default: '#1b2559',
    __color_main_text_nav_selected: '#185cff',
    __color_main_text_footer_default: '#dcdcdc',
    __color_main_text_footer_selected: '#ffffff',
    __color_main_text_search: '#777777',
    __color_main_text_banner_title: '#292d33',
    __color_main_text_banner_dis: '#9497a1',
    __color_main_text_link: '#185cff',
}; // 全局颜色

const config = {
    __nav_height: '96',
    __login_token_enc: 'developer666',
}; // 全局配置

const scroll_anchor = {
    __doc_scroll_anchor_top_api: 300, // 文档滚动锚点距离视口的实现距离
    __doc_scroll_anchor_top_md: 450, // 文档滚动锚点距离视口的实现距离
    __doc_scroll_anchor_click_cancel_time: 1000, // 文档滚动锚点点击触发重置时间
    __doc_scroll_anchor_api_default_list: [
        { name: 'API', level: 1, anchorId: 're_id_content_request_title', children: [] },
        { name: '请求体', level: 1, anchorId: 're_id_content_request_body', children: [] },
        { name: '响应体', level: 1, anchorId: 're_id_content_response_body', children: [] },
        { name: '调用示例', level: 1, anchorId: 're_id_content_example_md', children: [] },
    ],
}; //文档滚动锚点信息

const globalObj = {
    nav_item_list: nav_item_list, //导航栏列表
    group: group,
    docs_switch: docs_switch, // 开发文档类型
    docs_switch_list: docs_switch_list, // 文档类型列表
    search_tree_obj: search_tree_obj, //搜索中心目录树配置id
    search_tree_list: search_tree_list, //搜索中心目录树
    docs_content_type: docs_content_type, // 接口的文档类型
    docs_update_type: docs_update_type, // 更新日志类型
    docs_center_promise: docs_center_promise, // 开发者文档首页请求类型
    router_nav_path: router_nav_path, //导航栏路由类型
    router_type: router_type, // 路由地址
    router_path: router_path, //路由地址匹配类型
    color: color, // 全局颜色
    config: config, // 全局配置
    scroll_anchor: scroll_anchor, // 文档滚动锚点信息
};

export default globalObj;
